import { APP_CONFIG } from '@/project-config'
import { CloudComputingPowerRoutes } from 'cloud-computing-power/router'
import { createInvestFinancialRouter } from 'invest-financial'
import type { RouteLocationNormalizedGeneric, RouteRecordRaw } from 'vue-router'
import { getCommonRouter } from './common-router'
import { getCryptoRouter } from './crypto-router'
import { getRouterConfigMap } from './router-config-map'

export const isCrypto = import.meta.env.VITE_CRYPTO_EXCHANGE === '1'
const platform = import.meta.env.VITE_PLATFORM

export const getRouterConfig = (): RouteRecordRaw[] => {
  const diffRoutes: RouteRecordRaw[] = []

  if (import.meta.env.DEV) {
    console.log('isCrypto', isCrypto)
  }

  if (isCrypto) {
    diffRoutes.push(...getCryptoRouter())
  } else {
    diffRoutes.push(...CloudComputingPowerRoutes)
  }

  if (APP_CONFIG.isOpenInvestFinancial) {
    diffRoutes.push(...createInvestFinancialRouter())
  }

  const routerConfigMap = getRouterConfigMap()

  return [...getCommonRouter(), ...(routerConfigMap[platform] || []), ...diffRoutes]
}

export const getFullPathWithParentPath = (route: RouteLocationNormalizedGeneric) => {
  const joinStr = route.path.startsWith('/') ? '' : '/'
  return `${route.meta?.parentPath || ''}${joinStr}${route.path}`
}

export const handleModuleRoutes = (route: RouteRecordRaw[], modulePath: string) => {
  return route
    .map((item) => {
      const path = item.path
      if (path.includes(modulePath)) {
        item.path = path.replace(modulePath, '')
      }
      if (item.path.startsWith('/')) {
        item.path = item.path.slice(1)
      }

      return item
    })
    .filter((item) => !item.redirect)
}
